import { ApolloLink } from '@apollo/client/core';
import { uuid } from '../uuid';
import { getOrElse } from '../values';

export const setAppInsightsOperationIdLink = new ApolloLink((operation, forward) => {
  const context = operation.getContext();
  const operationId = getOrElse(
    operation.getContext().operationId,
    operation.operationName + '-' + uuid(),
  );
  const headers = context.headers != null ? context.headers : {};
  headers['request-id'] = operationId;
  operation.setContext({ headers, operationId });
  return forward != null ? forward(operation) : null;
});
